import * as Types from "../types/types";

export type functionParamsTypes = [
  boolean,
  (toggleSecondary: boolean) => void,
  boolean,
  (...args: unknown[]) => void,
  Types.SubItem,
  Types.Event,
  boolean,
  (toggleCollapsedMenu: boolean) => void,
  (toggleShowMenu: boolean) => void,
];

// Trigger opening of sub menu and alter toggle state
export const openSubMenuAndToggleUI = (
  isSmall: boolean,
  setToggleSecondary: (toggleSecondary: boolean) => void,
  toggleSecondary: boolean,
  openSubMenuFunction: (...args: unknown[]) => void,
  menu: Types.SubItem,
  event: Types.Event,
  isIntermediate: boolean,
  setIsMainMenuCollapsed: (toggleCollapsedMenu: boolean) => void,
  setShowSubMenu: (toggleShowMenu: boolean) => void,
) => {
  if (isSmall) {
    setToggleSecondary(!toggleSecondary);
  }
  openSubMenuFunction(menu, event);
  if (isSmall && isIntermediate) {
    setIsMainMenuCollapsed(true);
    setShowSubMenu(false);
  }
};
